export default __webpack_public_path__ + "static/media/dashboard_lecture_3.b3393e87.png";